import React from 'react'
import CreateStarChartOrgHeaderPresentation from '../../presentation/createStarChartOrg/CreateStarChartOrgHeaderPresentation'
import { CreateStarChartOrgHeaderPresentationProps } from '../../types/types'



const CreateStarChartOrgHeaderContainer: React.FC<CreateStarChartOrgHeaderPresentationProps> = ({starChartName,setStarChartName}) => {

  return (
    <CreateStarChartOrgHeaderPresentation starChartName={starChartName} setStarChartName={setStarChartName}/>
  )
}

export default CreateStarChartOrgHeaderContainer
